<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock>
        <v-tabs
          fixed-tabs
          :background-color="colorUnivLille"
          slider-color="white"
          :color="colorUnivLille"
          dark
          v-model="tab"
        >
          <v-tab
            ><v-icon left>mdi-format-list-numbered</v-icon>Les étapes pour se
            réorienter</v-tab
          >
          <v-tab><v-icon left>mdi-information</v-icon>Informations RGPD</v-tab>
        </v-tabs>

        <v-expand-transition>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <InfoSeReorienter
                    :campagnePrecoce="parametrage.campagnePrecoce"
                  >
                  </InfoSeReorienter>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <InfoRGPD> </InfoRGPD>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-expand-transition>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import InfoSeReorienter from "../components/InfoSeReorienter.vue";
import InfoRGPD from "../components/InfoRGPD.vue";
import ApiParametrageRepository from "@/repositories/ApiParametrageRepository";

export default {
  name: "About",
  components: { BaseBlock, InfoSeReorienter, InfoRGPD },
  data() {
    return {
      tab: null,
      colorUnivLille: "#1f8388",
      parametrage: {},
    };
  },
  methods: {
    async getParametrage() {
      try {
        const parametrage = await ApiParametrageRepository.getParametrage(
          this.parametrage
        );

        this.parametrage = parametrage;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
  },
  async created() {
    await this.getParametrage();
  },
};
</script>

<style scoped>
.v-tab {
  border: solid #2c959b;
}
.v-tab.v-tab--active {
  background-color: #ffffff;
  color: #1f8388;
  border: thick double #1f8388;
}
</style>
